import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Model } from 'ckeditor5';
import { merge, startWith, switchMap, catchError, map } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BugService } from 'src/app/private/services/bug.service';
import { ProjectService } from 'src/app/private/services/project.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { BugFormComponent } from '../bug-form/bug-form.component';
import { EpicService } from 'src/app/private/services/epic.service';
import { ProjectFeatureService } from 'src/app/private/services/project-feature.service';
import { UserStoryService } from 'src/app/private/services/user-story.service';
import { of as observableOf } from 'rxjs';

@Component({
  selector: 'app-bugs',
  templateUrl: './bugs.component.html',
  styleUrls: ['./bugs.component.scss']
})
export class BugsComponent {

  projectId: any;
  selectedTab = 0;
  displayedColumns = [
    "bug_code",
    "project_module",
    "user_story",
    "title",
    "type",
    "severity",
    "priority",
    "status",
    "assigned_to",
    "reproduction_count",
    "comment_count",
    "updatedAt",
    "action"
  ];

  dataSource = new MatTableDataSource<any>([]);
  totalRows = 0;
  pageSize = 25;
  pageSizeOptions = [10, 25, 100];
  currentPage = 0;
  formAction = 'Add';
  searchText = "";
  reloading = false;
  initialLoad = true;
  editData: any;
  currentBugId: any;
  
  // Filter properties
  selectedModule: string = '';
  selectedReportedBy: string = '';
  selectedAssignedTo: string = '';
  modules: any[] = [];
  users: any[] = [];
  filterArray: any = [];
  breadcrumbArray: any[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(BugFormComponent) bugFormComponent!: BugFormComponent;

  // ── Project Hierarchy State ────────────────────────────────────────────────
  listEpics: any[] = [];
  listFeatures: any[] = [];
  listUserStories: any[] = [];

  selectedListEpicId: any = null;
  selectedListFeatureId: any = null;
  selectedListUserStoryId: any = null;

  constructor(
    private route: ActivatedRoute,
    private api: BugService,
    private projectService: ProjectService,
    private userService: UsersService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private epicService: EpicService,
    private featureService: ProjectFeatureService,
    private userStoryService: UserStoryService
  ) {}

  ngOnInit() {
    this.projectId = this.route.snapshot.paramMap.get("project_id");
    this.getProject(this.projectId);
    this.loadFilterData();
    this.loadEpics();
  }

  ngAfterViewInit() {
    this.loadData();
  }
prettyAction(type: string) {
  return type.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}
  onTabChange(index: number) {
    this.selectedTab = index;
    this.paginator.pageIndex = 0;
    this.loadDataRefresh();
  }

  open(content: any) {
    this.formAction = "Add";
    this.editData = {}
    this.currentBugId = null;
    this.modalService.open(content, {
      windowClass: "bug-modal-xl",
      centered: true,
      backdrop: "static",
      scrollable: true
    });
  }

  openEdit(content: any, data: any) {
    this.formAction = 'Update';
    console.log("Editing Data:", data);
    this.editData = data;
    if (data && data.due_date) {
      data.due_date = new Date(data.due_date).toISOString().substring(0, 10)
    }

    this.currentBugId = data.bug_id;

    this.modalService.open(content, {
    windowClass: "bug-modal-xl",
    centered: true,
    backdrop: "static",
    scrollable: true
  });
  }

  searchFilter(value: string) {
    console.log("Search Text:", value);
    this.searchText = value;
    this.paginator.pageIndex = 0;
    this.loadDataRefresh();
  }
bugTabs = [
  { label: "All Bugs", value: "all" },
  { label: "Open", value: "open" },
  { label: "Re-open", value: "re-open" },
  { label: "In Progress", value: "in_progress" },
  { label: "In Review", value: "in_review" },
  { label: "Ready for Test", value: "ready_for_test" },
  { label: "Rejected", value: "rejected" },
  { label: "Closed", value: "closed" }
];
projectData:any;


changeTab(i: number) {
  this.selectedTab = i;
  this.paginator.pageIndex = 0;
  this.loadDataRefresh();
}
getProject(id: any) {
  this.projectService.getProjectById({
    project_id: id,
    client_id: this.localStorage.getClientId(),
    user_id: this.localStorage.getUserId(),
  }).subscribe(res => {
    this.projectData = res;
    this.breadcrumbArray = [
      { label: "Projects", link: "/main/manage-projects" },
      { label: this.projectData?.name ,link: "/main/manage-bugs/" + this.projectId + ""},

    ];
  });
}

loadModules() {
  this.projectService.getProjectModuleList({project_id: this.projectId}).subscribe({
    next: (res: any) => {
     res.forEach((element: any) => {
       this.modules.push({
         key: element.module_id,
         value: element.module_name
       });
     });
    },
    error: (e) => console.error('Error loading modules:', e)
  });
}

  loadUsers() {
    const param = {
      client_id: this.localStorage.getClientId(),
      project_id: this.projectId,
    };

    this.projectService.getProjectMembers(param).subscribe({
      next: (res: any) => {
        const list = this.projectService.parseProjectMembersResponse(res);
        list.forEach((element: any) => {
          this.users.push({
            key: element.user_id,
            value: element.fname + " " + element.lname
          });
        });
      },
      error: (e) => console.error('Error loading users:', e)
    });
  }

applyFilters() {
  this.paginator.pageIndex = 0;
  this.loadDataRefresh();
}

clearFilters() {
  this.selectedModule = '';
  this.selectedReportedBy = '';
  this.selectedAssignedTo = '';
  this.applyFilters();
}
loadFilterData() {
  this.loadModules();
  this.loadUsers();

  this.filterArray = [
    { key: 'bug_code', value: 'Bug Code', type:'text' },
    { key: 'module_id', value: 'Select Module', type:'select',options: this.modules },
    { key: 'reported_by', value: 'Select Reporter', type:'select',options: this.users },
    { key: 'assigned_to', value: 'Select Assignee', type:'select',options: this.users },
    { key: 'status', value: 'Select Status', type:'select',options: [
  { value: "Open", key: "open" },
  { value: "Re-open", key: "re-open" },
  { value: "In Progress", key: "in_progress" },
  { value: "In Review", key: "in_review" },
  { value: "Ready for Test", key: "ready_for_test" },
  { value: "Rejected", key: "rejected" },
  { value: "Closed", key: "closed" }] },
  { key: 'environment', value: 'Select Environment', type:'select',options: [
    { value: "Development", key: "dev" },
    { value: "QA", key: "qa" },
    { value: "Staging", key: "stage" },
    { value: "Production", key: "prod" }
  ] },
  { key: 'priority', value: 'Select Priority', type:'select',options: [
    { value: "Low", key: "low" },
    { value: "Medium", key: "medium" },
    { value: "High", key: "high" },
    { value: "Critical", key: "critical" }
  ] },
  { key: 'severity', value: 'Select Severity', type:'select',options: [
    { value: "Low", key: "low" },
    { value: "Medium", key: "medium" },
    { value: "High", key: "high" },
    { value: "Critical", key: "critical" }
  ] },
 

  ];
}

hasActiveFilters(): boolean {
  return !!(this.selectedModule || this.selectedReportedBy || this.selectedAssignedTo);
}

  loadData() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(
      this.sort.sortChange,
      this.paginator.page
    )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.reloading = true;

          const whereClause: any = {
            client_id: this.localStorage.getClientId(),
            project_id: this.projectId,
            status: this.selectedTab === 0 ? undefined : this.bugTabs[this.selectedTab].value
          };

          // Add filter conditions
          if (this.selectedModule) {
            whereClause.module_id = this.selectedModule;
          }
          if (this.selectedReportedBy) {
            whereClause.reported_by = this.selectedReportedBy;
          }
          if (this.selectedAssignedTo) {
            whereClause.assigned_to = this.selectedAssignedTo;
          }
          if (this.selectedListEpicId) {
            whereClause.epic_id = this.selectedListEpicId;
          }
          if (this.selectedListFeatureId) {
            whereClause.feature_id = this.selectedListFeatureId;
          }
          if (this.selectedListUserStoryId) {
            whereClause.user_story_id = this.selectedListUserStoryId;
          }
          //add logic if filter key is from dropdown then pass into where clause as key.value which is comes in this.searchText
          
          

          let param = {
            page: this.paginator.pageIndex * this.paginator.pageSize,
            limit: this.paginator.pageSize,
            user_id: this.localStorage.getUserId(),
            where: whereClause,
            filter: this.searchText ? this.searchText  : {},
            order: {
              col: "\"bug\".\"updated_at\"",
              dir: "DESC"
            }
          };

          this.filterArray.forEach((element: any) => {
            if (element.type === 'select') {
              if(this.searchText[element.key]){
                param.where[element.key] = this.searchText[element.key];
                param.filter = {};
              }
            }
            else {
              this.searchText = this.searchText;
            }
          });

          return this.api.getAllBugs(param).pipe(
            catchError(() => observableOf(null))
          );
        }),
        map((response: any) => {
          this.initialLoad = false;
          this.reloading = false;

          if (!response) return [];

          this.totalRows = response.count;
          return response.rows;
        })
      )
      .subscribe(data => {
        this.dataSource = new MatTableDataSource(data);
      });
  }

  loadDataRefresh() {
    this.loadData();
  }
  formSubmit(payload: any) {
    if (!payload) return;
      this.btnLoading = true;
    if (this.formAction === 'Update') {
        payload.bug_id = this.currentBugId;
        console.log("Form Submitted for Update:", payload);
        this.api.updateBug(payload).subscribe({
          next: (res: any) => this.onFormSuccess(),
          error: (e: any) => {  
            console.error('Update bug error:', e);
            this.btnLoading = false;
            
            // Show error toast
            const errorMessage = e?.error?.message || e?.message || 'Failed to update bug. Please try again.';
            this.toastr.error(errorMessage, 'Update Failed');
           }
        });
        return;
    } 
      
    console.log("Form Submitted:", payload);
    this.api.createBug(payload).subscribe({
      next: (res: any) => this.onFormSuccess(),
      error: (e: any) => {  
            console.error('Create bug error:', e);
            this.btnLoading = false;
            
            // Show error toast
            const errorMessage = e?.error?.message || e?.message || 'Failed to create bug. Please try again.';
            this.toastr.error(errorMessage, 'Creation Failed');
           }
    });
  }
  onFormSuccess() {
    // Clear the comment field before closing
    if (this.bugFormComponent) {
      this.bugFormComponent.clearCommentField();
    }
    
    this.modalService.dismissAll();
    this.btnLoading = false;
    this.loadDataRefresh();
  }


  openDelete(modal: any, data: any) {
    this.editData = data;
    this.modalService.open(modal, {
      size: "md",
      centered: true,
      backdrop: "static",
      scrollable: true
    })
  }
  btnLoading = false;
  confirmDelete() {
    if (!this.editData || !this.editData.bug_id) return;
    this.btnLoading = true
    this.api.deleteBug({"bug_id":this.editData.bug_id,project_id:this.projectId}).subscribe({
      next: (res: any) => {
        this.btnLoading = false
        this.modalService.dismissAll();
        this.loadDataRefresh();
      },
      error: (e: any) => {
        this.btnLoading = false
        console.error(e)
      }
    });
  }
  handleClosDialog() {
    this.modalService.dismissAll();
  }
  openDetails(data: any) {}

  // ── List Hierarchy Cascading Helpers ───────────────────────────────────────
  loadEpics() {
    this.epicService.getAllEpics({
      client_id: this.localStorage.getClientId(),
      project_id: this.projectId,
      limit: 1000
    }).subscribe({
      next: (res: any) => {
        this.listEpics = res?.rows || res?.data?.rows || res?.data || [];
      }
    });
  }

  onListEpicChange(epicId: any) {
    this.selectedListEpicId = epicId ? Number(epicId) : null;
    this.selectedListFeatureId = null;
    this.selectedListUserStoryId = null;
    this.listFeatures = [];
    this.listUserStories = [];

    if (this.selectedListEpicId) {
      this.featureService.getAllFeatures({
        client_id: this.localStorage.getClientId(),
        epic_id: this.selectedListEpicId,
        limit: 1000
      }).subscribe({
        next: (res: any) => {
          this.listFeatures = res?.rows || res?.data?.rows || res?.data || [];
        }
      });
    }

    this.paginator.pageIndex = 0;
    this.loadData();
  }

  onListFeatureChange(featureId: any) {
    this.selectedListFeatureId = featureId ? Number(featureId) : null;
    this.selectedListUserStoryId = null;
    this.listUserStories = [];

    if (this.selectedListFeatureId) {
      this.userStoryService.getAllUserStories({
        client_id: this.localStorage.getClientId(),
        feature_id: this.selectedListFeatureId,
        limit: 1000
      }).subscribe({
        next: (res: any) => {
          this.listUserStories = res?.rows || res?.data?.rows || res?.data || [];
        }
      });
    }

    this.paginator.pageIndex = 0;
    this.loadData();
  }

  onListUserStoryChange(storyId: any) {
    this.selectedListUserStoryId = storyId ? Number(storyId) : null;
    this.paginator.pageIndex = 0;
    this.loadData();
  }
}

